export const AppointmentStatus = [
    { id: 'pending', name: 'Pending' },
    { id: 'confirmed',  name: 'Confirmed' },
];
